import { type UseApiHook } from '@/hooks/useApi'
import { sessionEndSpec } from 'aevocam-rest-api-spec'

/** End the current user's session */
export async function sessionEnd(
  api: UseApiHook,
  tenantId: string | undefined
) {
  await api.request(sessionEndSpec, {
    path: {
      tenant: tenantId ?? '',
    },
  })
}
